// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"179":"70567cde","839":"1d885c71"}[chunkId] + ".js";
};